var e = /* @__PURE__ */ ((a) => (a.tableSearchLabel = "tableSearchLabel", a.tableSearchClearAriaLabel = "tableSearchClearAriaLabel", a.tableSortPrefix = "tableSortAscendingPrefix", a.tableSortAscendingSuffix = "tableSortAscendingSuffix", a.tableSortDescendingSuffix = "tableSortDescendingSuffix", a.tableSortDefaultSuffix = "tableSortDefaultSuffix", a))(e || {});
const r = {
  [e.tableSearchLabel]: "Hledat zde",
  [e.tableSearchClearAriaLabel]: "Vymazat hledání",
  [e.tableSortPrefix]: "Seřadit sloupec",
  [e.tableSortAscendingSuffix]: "vzestupně",
  [e.tableSortDescendingSuffix]: "sestupně",
  [e.tableSortDefaultSuffix]: "ve výchozím pořadí"
}, t = {
  [e.tableSearchLabel]: "Søg her",
  [e.tableSearchClearAriaLabel]: "Ryd søgning",
  [e.tableSortPrefix]: "Sorter kolonne",
  [e.tableSortAscendingSuffix]: "i stigende rækkefølge",
  [e.tableSortDescendingSuffix]: "i faldende rækkefølge",
  [e.tableSortDefaultSuffix]: "i standardrækkefølge"
}, l = {
  [e.tableSearchLabel]: "Hier suchen",
  [e.tableSearchClearAriaLabel]: "Suche löschen",
  [e.tableSortPrefix]: "Spalte sortieren",
  [e.tableSortAscendingSuffix]: "aufsteigend",
  [e.tableSortDescendingSuffix]: "absteigend",
  [e.tableSortDefaultSuffix]: "in Standardreihenfolge"
}, n = {
  [e.tableSearchLabel]: "Hier suchen",
  [e.tableSearchClearAriaLabel]: "Suche löschen",
  [e.tableSortPrefix]: "Spalte sortieren",
  [e.tableSortAscendingSuffix]: "aufsteigend",
  [e.tableSortDescendingSuffix]: "absteigend",
  [e.tableSortDefaultSuffix]: "in Standardreihenfolge"
}, i = {
  [e.tableSearchLabel]: "Αναζήτηση εδώ",
  [e.tableSearchClearAriaLabel]: "Εκκαθάριση αναζήτησης",
  [e.tableSortPrefix]: "Ταξινόμηση στήλης",
  [e.tableSortAscendingSuffix]: "με αύξουσα σειρά",
  [e.tableSortDescendingSuffix]: "με φθίνουσα σειρά",
  [e.tableSortDefaultSuffix]: "στην προεπιλεγμένη σειρά"
}, S = {
  [e.tableSearchLabel]: "Search here",
  [e.tableSearchClearAriaLabel]: "Clear search",
  [e.tableSortPrefix]: "Sort column",
  [e.tableSortAscendingSuffix]: "in ascending order",
  [e.tableSortDescendingSuffix]: "in descending order",
  [e.tableSortDefaultSuffix]: "in default order"
}, o = {
  [e.tableSearchLabel]: "Search here",
  [e.tableSearchClearAriaLabel]: "Clear search",
  [e.tableSortPrefix]: "Sort column",
  [e.tableSortAscendingSuffix]: "in ascending order",
  [e.tableSortDescendingSuffix]: "in descending order",
  [e.tableSortDefaultSuffix]: "in default order"
}, b = {
  [e.tableSearchLabel]: "Search here",
  [e.tableSearchClearAriaLabel]: "Clear search",
  [e.tableSortPrefix]: "Sort column",
  [e.tableSortAscendingSuffix]: "in ascending order",
  [e.tableSortDescendingSuffix]: "in descending order",
  [e.tableSortDefaultSuffix]: "in default order"
}, f = {
  [e.tableSearchLabel]: "Search here",
  [e.tableSearchClearAriaLabel]: "Clear search",
  [e.tableSortPrefix]: "Sort column",
  [e.tableSortAscendingSuffix]: "in ascending order",
  [e.tableSortDescendingSuffix]: "in descending order",
  [e.tableSortDefaultSuffix]: "in default order"
}, c = {
  [e.tableSearchLabel]: "Buscar aquí",
  [e.tableSearchClearAriaLabel]: "Borrar búsqueda",
  [e.tableSortPrefix]: "Ordenar columna",
  [e.tableSortAscendingSuffix]: "en orden ascendente",
  [e.tableSortDescendingSuffix]: "en orden descendente",
  [e.tableSortDefaultSuffix]: "en orden predeterminado"
}, s = {
  [e.tableSearchLabel]: "Buscar aquí",
  [e.tableSearchClearAriaLabel]: "Borrar búsqueda",
  [e.tableSortPrefix]: "Ordenar columna",
  [e.tableSortAscendingSuffix]: "en orden ascendente",
  [e.tableSortDescendingSuffix]: "en orden descendente",
  [e.tableSortDefaultSuffix]: "en orden predeterminado"
}, d = {
  [e.tableSearchLabel]: "Hae täältä",
  [e.tableSearchClearAriaLabel]: "Tyhjennä haku",
  [e.tableSortPrefix]: "Lajittele sarake",
  [e.tableSortAscendingSuffix]: "nousevassa järjestyksessä",
  [e.tableSortDescendingSuffix]: "laskevassa järjestyksessä",
  [e.tableSortDefaultSuffix]: "oletusjärjestyksessä"
}, u = {
  [e.tableSearchLabel]: "Rechercher ici",
  [e.tableSearchClearAriaLabel]: "Effacer la recherche",
  [e.tableSortPrefix]: "Trier la colonne",
  [e.tableSortAscendingSuffix]: "par ordre croissant",
  [e.tableSortDescendingSuffix]: "par ordre décroissant",
  [e.tableSortDefaultSuffix]: "dans l'ordre par défaut"
}, x = {
  [e.tableSearchLabel]: "Rechercher ici",
  [e.tableSearchClearAriaLabel]: "Effacer la recherche",
  [e.tableSortPrefix]: "Trier la colonne",
  [e.tableSortAscendingSuffix]: "par ordre croissant",
  [e.tableSortDescendingSuffix]: "par ordre décroissant",
  [e.tableSortDefaultSuffix]: "dans l'ordre par défaut"
}, h = {
  [e.tableSearchLabel]: "Rechercher ici",
  [e.tableSearchClearAriaLabel]: "Effacer la recherche",
  [e.tableSortPrefix]: "Trier la colonne",
  [e.tableSortAscendingSuffix]: "par ordre croissant",
  [e.tableSortDescendingSuffix]: "par ordre décroissant",
  [e.tableSortDefaultSuffix]: "dans l'ordre par défaut"
}, g = {
  [e.tableSearchLabel]: "Rechercher ici",
  [e.tableSearchClearAriaLabel]: "Effacer la recherche",
  [e.tableSortPrefix]: "Trier la colonne",
  [e.tableSortAscendingSuffix]: "par ordre croissant",
  [e.tableSortDescendingSuffix]: "par ordre décroissant",
  [e.tableSortDefaultSuffix]: "dans l'ordre par défaut"
}, D = {
  [e.tableSearchLabel]: "Keresés itt",
  [e.tableSearchClearAriaLabel]: "Keresés törlése",
  [e.tableSortPrefix]: "Oszlop rendezése",
  [e.tableSortAscendingSuffix]: "növekvő sorrendben",
  [e.tableSortDescendingSuffix]: "csökkenő sorrendben",
  [e.tableSortDefaultSuffix]: "alapértelmezett sorrendben"
}, A = {
  [e.tableSearchLabel]: "Cerca qui",
  [e.tableSearchClearAriaLabel]: "Cancella ricerca",
  [e.tableSortPrefix]: "Ordina colonna",
  [e.tableSortAscendingSuffix]: "in ordine crescente",
  [e.tableSortDescendingSuffix]: "in ordine decrescente",
  [e.tableSortDefaultSuffix]: "in ordine predefinito"
}, L = {
  [e.tableSearchLabel]: "Zoek hier",
  [e.tableSearchClearAriaLabel]: "Zoekopdracht wissen",
  [e.tableSortPrefix]: "Kolom sorteren",
  [e.tableSortAscendingSuffix]: "in oplopende volgorde",
  [e.tableSortDescendingSuffix]: "in aflopende volgorde",
  [e.tableSortDefaultSuffix]: "in standaardvolgorde"
}, C = {
  [e.tableSearchLabel]: "Søk her",
  [e.tableSearchClearAriaLabel]: "Tøm søk",
  [e.tableSortPrefix]: "Sorter kolonne",
  [e.tableSortAscendingSuffix]: "i stigende rekkefølge",
  [e.tableSortDescendingSuffix]: "i synkende rekkefølge",
  [e.tableSortDefaultSuffix]: "i standardrekkefølge"
}, k = {
  [e.tableSearchLabel]: "Szukaj tutaj",
  [e.tableSearchClearAriaLabel]: "Wyczyść wyszukiwanie",
  [e.tableSortPrefix]: "Sortuj kolumnę",
  [e.tableSortAscendingSuffix]: "w porządku rosnącym",
  [e.tableSortDescendingSuffix]: "w porządku malejącym",
  [e.tableSortDefaultSuffix]: "w domyślnej kolejności"
}, T = {
  [e.tableSearchLabel]: "Pesquisar aqui",
  [e.tableSearchClearAriaLabel]: "Limpar pesquisa",
  [e.tableSortPrefix]: "Ordenar coluna",
  [e.tableSortAscendingSuffix]: "em ordem crescente",
  [e.tableSortDescendingSuffix]: "em ordem decrescente",
  [e.tableSortDefaultSuffix]: "em ordem padrão"
}, p = {
  [e.tableSearchLabel]: "Căutați aici",
  [e.tableSearchClearAriaLabel]: "Ștergeți căutarea",
  [e.tableSortPrefix]: "Sortați coloana",
  [e.tableSortAscendingSuffix]: "în ordine crescătoare",
  [e.tableSortDescendingSuffix]: "în ordine descrescătoare",
  [e.tableSortDefaultSuffix]: "în ordine implicită"
}, P = {
  [e.tableSearchLabel]: "Sök här",
  [e.tableSearchClearAriaLabel]: "Rensa sökning",
  [e.tableSortPrefix]: "Sortera kolumn",
  [e.tableSortAscendingSuffix]: "i stigande ordning",
  [e.tableSortDescendingSuffix]: "i fallande ordning",
  [e.tableSortDefaultSuffix]: "i standardordning"
}, m = {
  [e.tableSearchLabel]: "Burada ara",
  [e.tableSearchClearAriaLabel]: "Aramayı temizle",
  [e.tableSortPrefix]: "Sütunu sırala",
  [e.tableSortAscendingSuffix]: "artan düzende",
  [e.tableSortDescendingSuffix]: "azalan düzende",
  [e.tableSortDefaultSuffix]: "varsayılan sırada"
};
export {
  r as DataTableCS,
  t as DataTableDA,
  l as DataTableDE,
  n as DataTableDEAT,
  i as DataTableEL,
  S as DataTableEN,
  o as DataTableENCA,
  b as DataTableENGB,
  f as DataTableENUS,
  c as DataTableES,
  s as DataTableESMX,
  d as DataTableFI,
  u as DataTableFR,
  x as DataTableFRBE,
  h as DataTableFRCA,
  g as DataTableFRCH,
  D as DataTableHU,
  A as DataTableIT,
  L as DataTableNL,
  C as DataTableNO,
  k as DataTablePL,
  T as DataTablePT,
  p as DataTableRO,
  P as DataTableSV,
  m as DataTableTR
};
